import {WsInsuranceSubscriptionSortField} from '@lifeislife/lifeislife-ws-api';
import {WsSubscriptionSortField} from '@lifeislife/lifeislife-ws-api';

export type InsuranceSubscriptionSortField = WsInsuranceSubscriptionSortField | WsSubscriptionSortField;
export const InsuranceSubscriptionSortField = {
  ...WsInsuranceSubscriptionSortField, ...WsSubscriptionSortField,
};
